module.exports = __webpack_public_path__ + "media/images/game/how_it_works/vytvorit_tim-30d8c46fb6992e588ac6e48b87b59204.png";